import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Icon from './Icon';

type LegendItem = {
  key: string;
  label: string;
  colorClass?: string;
  colorStyle?: string;
};

const NODE_LEGEND_ITEMS: LegendItem[] = [
  {
    key: 'root',
    colorStyle: '#6b5eae',
    label: 'خوشه اصلی'
  },
  { key: 'cluster', colorClass: 'bg-primary', label: 'خوشه' },
  { key: 'leaf', colorClass: 'bg-success', label: 'کلمه' },
  { key: 'match', colorClass: 'bg-warning', label: 'جستجو' },
  {
    key: 'pin',
    colorStyle: 'var(--falcon-orange, #fd7e14)',
    label: 'پین'
  }
];

const BADGE_LEGEND_ITEMS: LegendItem[] = [
  { key: 'volume', colorClass: 'bg-primary', label: 'میزان جستجو' },
  { key: 'kd', colorClass: 'bg-info', label: 'KD سختی' },
  { key: 'len', colorClass: 'bg-info', label: 'L میانگین طول کلمات' },
  { key: 'I', colorClass: 'bg-info', label: 'I اطلاعاتی' },
  { key: 'C', colorClass: 'bg-warning', label: 'C تجاری' },
  { key: 'T', colorClass: 'bg-success', label: 'T تراکنشی' },
  { key: 'N', colorClass: 'bg-secondary', label: 'N ناوبری' }
];

function LegendList({ items }: { items: LegendItem[] }) {
  return (
    <div className="d-flex flex-column gap-2">
      {items.map(item => (
        <span
          key={item.key}
          className="d-inline-flex align-items-center gap-2 text-nowrap"
        >
          <i
            className={`rounded-circle d-inline-block flex-shrink-0 ${item.colorClass || ''}`}
            style={{
              width: 10,
              height: 10,
              ...(item.colorStyle ? { background: item.colorStyle } : {})
            }}
          />
          {item.label}
        </span>
      ))}
    </div>
  );
}

/** Compact legend trigger — full guide opens in a popover. */
export default function ClusterBadgeLegend({
  showBadges = true
}: {
  showBadges?: boolean;
}) {
  const popover = (
    <Popover
      id="cluster-legend-popover"
      className="cluster-legend"
      style={{ maxWidth: 260 }}
    >
      <Popover.Header className="fs--1 fw-semi-bold py-2">راهنما</Popover.Header>
      <Popover.Body className="fs--2 text-600 py-2" dir="rtl">
        <div className="fw-semi-bold text-700 mb-2">نوع نود</div>
        <LegendList items={NODE_LEGEND_ITEMS} />
        {showBadges ? (
          <>
            <hr className="my-2 text-300" />
            <div className="fw-semi-bold text-700 mb-2">نشان‌ها</div>
            <LegendList items={BADGE_LEGEND_ITEMS} />
          </>
        ) : null}
      </Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger
      trigger="click"
      rootClose
      placement="bottom-end"
      overlay={popover}
    >
      <Button
        type="button"
        variant="link"
        size="sm"
        className="cluster-legend d-inline-flex align-items-center gap-1 border rounded-2 px-2 py-1 fs--2 text-600 bg-body text-decoration-none"
        aria-label="راهنما"
      >
        <Icon name="eye" className="fs--2" />
        راهنما
      </Button>
    </OverlayTrigger>
  );
}
